<template>
  <div>
    <div
      v-if="showModal"
      class="modal fade show d-block"
      tabindex="-1"
      role="dialog"
      style="background: rgba(0, 0, 0, 0.7);"
    >
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" style="color: #3498db; font-size: 1.1rem; font-weight: 600;">
              <i class="fas fa-chart-line"></i> Generated Looker Links
            </h5>
            <button type="button" class="close" @click="closeModal">
              <span>&times;</span>
            </button>
          </div>

          <div class="modal-body">
            <div
              v-for="item in parsedLinks"
              :key="item.name"
              class="looker-link-row"
            >
              <div class="folder-name">{{ formatName(item.name) }}</div>
              <div class="link-details">
                <a :href="item.link" target="_blank" rel="noopener noreferrer">
                  {{ item.link }}
                  <i class="fas fa-external-link-alt" style="margin-left: 4px; font-size: 0.8em;"></i>
                </a>
                <span class="look-id">Look ID: {{ item.lookId }}</span>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModal">
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { parseLookerLinkObject } from '../../util/lookerLinkHelper';

export default {
  props: {
    links: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      showModal: false
    };
  },
  computed: {
    parsedLinks() {
      if (!this.links) return [];
      return parseLookerLinkObject(this.links);
    }
  },
  methods: {
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
    formatName(name) {
      return name.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    }
  }
};
</script>

<style scoped>
.modal-content {
  background-color: #2c3e50;
  color: #ecf0f1;
  border-radius: 8px;
}

.modal-header {
  background-color: #2c3e50;
  color: #ecf0f1;
  border-radius: 8px 8px 0 0;
  border-bottom: 1px solid #dee2e6;
  margin-bottom: 2px;
}

.modal-footer {
  border-top: 1px solid #dee2e6;
  margin-top: 2px;
}

.looker-link-row {
  padding: 12px;
  border-bottom: 1px solid #dee2e6;
}

.looker-link-row:last-child {
  border-bottom: none;
}

.folder-name {
  font-weight: 600;
  font-size: 0.95rem;
  margin-bottom: 4px;
  color: #3498db;
}

.link-details a {
  color: #ecf0f1;
  text-decoration: underline;
  word-break: break-all;
}

.link-details a:hover {
  color: #3498db;
}

.look-id {
  display: block;
  font-size: 0.8rem;
  color: #95a5a6;
  margin-top: 2px;
}
</style>
